import React, { useContext, useRef } from 'react';
import { Dropdown } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { IconLogout } from '@bynder/icons';

import { AbilityContext } from '../../abilities/Can';
import { CSRF } from '../../helpers/csrf';

export function LogoutItem() {
	const ability = useContext(AbilityContext);
	const { translate } = useTranslate();

	const logoutUrl = ability.can('show', 'pynder_logout') ? '/pylogout/' : '/user/logout/';

	const formRef = useRef<HTMLFormElement>(null);

	const submitForm = () => {
		formRef.current?.submit();
	};

	return (
		<>
			<Dropdown.Divider />
			<Dropdown.Item onClick={submitForm} icon={<IconLogout />}>
				{translate('generalLogout')}
				<form ref={formRef} action={logoutUrl} method="post" hidden>
					<input name="csrf" value={CSRF} type="hidden" />
				</form>
			</Dropdown.Item>
		</>
	);
}
